import API from 'src/api'
import { http } from '../boot/axios'

export default {
  getReports () {
    return http.get(`${API.GRAPHQL_URL}power-bi/reports`)
  },
  getEmbedToken (reportId) {
    return http.get(`${API.GRAPHQL_URL}power-bi/reports/${reportId}/embed-token`)
  },
  // reportId es el slug interno (agenda, tablero-aperturas), nunca el GUID de
  // Power BI: el backend lo resuelve contra el catalogo del usuario.
  startExport (reportId, payload) {
    return http.post(`${API.GRAPHQL_URL}power-bi/reports/${reportId}/exports`, payload)
  },
  getExportStatus (exportJobId) {
    return http.get(`${API.GRAPHQL_URL}power-bi/exports/${exportJobId}`)
  },
  // Acuse de recibo: es lo que le dice al backend que el usuario ya tiene su
  // archivo y que no hace falta mandarle la notificacion diferida.
  ackExportDownload (exportJobId) {
    return http.post(`${API.GRAPHQL_URL}power-bi/exports/${exportJobId}/ack`)
  },
  // Acuse de que el usuario vio el fallo en vivo (dialogo abierto cuando el
  // polling trajo el estado failed): el equivalente de ackExportDownload para
  // el camino de error, para que el job diferido no mande campanita de mas.
  ackExportFailure (exportJobId) {
    return http.post(`${API.GRAPHQL_URL}power-bi/exports/${exportJobId}/ack-failure`)
  },
  // La URL viene completa desde el backend (ruta del token de descarga), no se
  // arma aqui. El interceptor de boot/axios ya sube el timeout a 120s para
  // responseType blob.
  downloadExportFile (url) {
    return http.get(url, { responseType: 'blob' })
  }
}
